export const DESCRIPTIVE_SHOVELER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.DescriptiveShovelerWidgetElement';
